module.exports = __webpack_public_path__ + "static/media/P12.630c7aaf.jpg";